import { Label } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Button } from '@mui/material';
import { memo } from 'react';
import type { ClearButtonProps as Props } from './types';

export const ClearButton = memo(
  ({ className, onClick, text, count }: Props) => {
    return (
      <Button
        className={classnames('ClearButton', className)}
        variant="outlined"
        size="xsmall"
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
        disableRipple
        disableFocusRipple
        disableTouchRipple
      >
        <Box display={'flex'} alignItems={'center'} gap={0.5}>
          {text ?? 'Clear'}
          {!!count && (
            <Label size="xxxsmall" color="primary" variant="filled">
              {count}
            </Label>
          )}
        </Box>
      </Button>
    );
  }
);

ClearButton.displayName = 'ClearButton';
